<template>
  <div v-bind:class="{'pb-0 hidden xl:block md:pb-16 lg:pb-16 xl:pb-16': !supportedPages.includes(path)}">
    <header class="fixed top-0 z-50 w-full bg-white shadow-md lg:flex xl:flex">
      <div class="container mx-auto">
        <div class="flex w-full h-16 py-2">
          <div class="flex items-center justify-start w-1/2">
            <router-link :to="{path: `/${language === 'es' ? language : '' }`}">
              <img @click="homeClicked" class="w-40 sm:w-48 pl-2 pr-4 mr-16 lg:pr-0" src="/logo.svg" alt="JW Perfect Match" />
            </router-link>
            <h1 v-if="!hasValidUser() && $route.name !== 'jw-dating'"
              class="hidden p-0 m-0 text-xl font-bold text-black-darkest lg:block"
            >{{ $t('messages.general.page_title')}}</h1>
            <p v-if="!hasValidUser() && $route.name === 'jw-dating'"
              class="hidden p-0 m-0 text-xl font-bold text-black-darkest lg:block"
            >{{ $t('messages.general.page_title')}}</p>
          </div>
          <div class="flex items-center flex-1 justify-end w-1/2">
            <ul class="flex no-list">
              <li class="flex items-center justify-center cursor-pointer phone:pr-0" :class="[!hasValidUser() ? 'pr-2' : 'px-6']">
                <router-link :to="{path: `/${language === 'es' ? language : '' }`}" class="flex font-semibold text-black no-underline hover:text-jblue-primary" >
                  <span @click="homeClicked">{{ $t('messages.general.home') }}</span>
                </router-link>
              </li>
              <li v-if="hasValidUser()" class="px-6 dropdown">
                <div
                  class="w-24 cursor-pointer dropdown__header"
                  v-bind:class="{ 'is-active': isActive }"
                  @click="toggleDropdown()"
                >
                  <a
                    v-if="user.activity_notification > 0"
                    class="flex w-32 font-semibold text-black no-underline hover:text-jblue-primary"
                  >
                    {{ $t('messages.general.my_activity') }}
                    <span
                      class="flex items-center justify-center w-6 h-6 ml-2 text-xs font-medium text-white bg-blue-500 rounded-full"
                    >{{ user.activity_notification }}</span>
                  </a>
                  <a
                    v-else
                    class="flex w-32 font-semibold text-black no-underline hover:text-jblue-primary"
                  >{{ $t('messages.general.my_activity') }}</a>
                </div>
                <div class="absolute mt-6 bg-gray-300 rounded dropdown__content">
                  <ul class="px-6 leading-loose no-list">
                    <router-link to="/visits" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.visits_to_your_profile') }}</p>
                    </router-link>
                    <router-link to="/invitations" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="flex items-center font-semibold text-gray-700 hover:text-blue-400"
                      >
                        {{ $t('messages.general.invitations') }}
                        <span
                          v-if="user.activity_notification > 0"
                          class="flex items-center justify-center w-6 h-6 ml-2 text-xs font-medium text-white bg-blue-500 rounded-full"
                        >{{ user.activity_notification }}</span>
                      </p>
                    </router-link>
                    <router-link to="/favorites" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.favorites') }}</p>
                    </router-link>
                    <router-link to="/reciprocal-favorites" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.reciprocal_favorites') }}</p>
                    </router-link>
                    <router-link to="/share" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.tell_your_friends') }}</p>
                    </router-link>
                    <router-link to="/stories" class="no-underline">
                      <p
                        @click="isActive = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.stories') }}</p>
                    </router-link>
                    <router-link to="/blocked-profile" class="no-underline">
                      <p
                        @click="isShow = false"
                        class="font-semibold text-gray-700 hover:text-blue-400"
                      >{{ $t('messages.general.locked_profiles') }}</p>
                    </router-link>
                  </ul>
                </div>
              </li>
              <li
                v-if="hasValidUser()"
                class="flex items-center justify-center px-6 hover:text-jblue-primary"
                @click="hideDropdowns"
              >
                <router-link
                  class="flex items-center font-semibold text-black no-underline hover:text-jblue-primary"
                  to="/search"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    width="16"
                    height="16"
                    class="mr-2 hover:text-jblue-primary"
                  >
                    <g>
                      <path
                        d="M495,466.2L377.2,348.4c29.2-35.6,46.8-81.2,46.8-130.9C424,103.5,331.5,11,217.5,11C103.4,11,11,103.5,11,217.5   S103.4,424,217.5,424c49.7,0,95.2-17.5,130.8-46.7L466.1,495c8,8,20.9,8,28.9,0C503,487.1,503,474.1,495,466.2z M217.5,382.9   C126.2,382.9,52,308.7,52,217.5S126.2,52,217.5,52C308.7,52,383,126.3,383,217.5S308.7,382.9,217.5,382.9z"
                      />
                    </g>
                  </svg>
                  {{ $t('messages.general.search') }}
                </router-link>
              </li>
              <li v-if="hasValidUser()" @click="openChat" class="flex items-center justify-center px-6 cursor-pointer">
                <a class="flex font-semibold text-black no-underline hover:text-jblue-primary">
                  {{ $t('messages.general.messages') }}
                  <span
                    class="flex items-center justify-center w-6 h-6 ml-2 text-xs font-medium text-white bg-blue-500 rounded-full"
                    v-if="messagesCount"
                  >{{ messagesCount > 99 ? '+99' : messagesCount }}</span>
                </a>
              </li>
            </ul>
            <router-link
              class="hidden mx-4 font-semibold text-black no-underline hover:text-jblue-primary lg:block"
              to="/support"
              rel="nofollow"
            >{{ $t('messages.general.support') }}</router-link>
            <router-link
              v-if="!hasValidUser()"
              class="pr-2 phone:px-2 py-2 text-xs font-bold text-white border rounded bg-jblue-primary sm:mx-4 md:text-md sm:px-8 sm:py-2 hover:border hover:bg-white hover:text-jblue-primary mx-2"
              to="/login"
              rel="nofollow"
            >{{ $t('messages.general.login') }}</router-link>
            <router-link
               v-if="hasValidUser()"
              class="px-5 py-2 mx-4 font-semibold text-white no-underline border rounded bg-jblue-primary hover:text-jblue-primary hover:bg-white hover:border-jblue-primary"
              to="/subscriptions"
              :class="(user) ? user.subscription_status === 'active' ? 'invisible' : 'visible' : ''"
            >{{ $t('messages.general.subscribe') }}</router-link>
            <div
              v-if="hasValidUser()"
              class="px-4 dropdown no-list">
              <div
                class="flex items-center w-24 mr-5 dropdown__header"
                v-bind:class="{ 'is-showProfile': isShow }"
                @click="toggleDropdownProfile()"
              >
                <img
                  v-if="user.pictures.length > 0"
                  class="object-cover w-10 h-10 rounded-full"
                  :src="coverUrl"
                  alt="jw dating avatar"
                />
                <img
                  v-else
                  class="object-cover w-10 h-10 rounded-full"
                  src="/storage/image/placeholder-user.jpg"
                  alt="jw dating avatar"
                />

                <a class="flex items-center px-2 font-semibold text-black no-underline">
                  {{ $t('messages.general.profile') }}
                  <span class="mb-1 ml-2 text-xl md:mb-2 text-blue-dark">&#x2304;</span>
                </a>
              </div>
              <div v-if="hasValidUser()" class="absolute mt-4 -ml-16 bg-gray-300 rounded dropdown__content">
                <ul class="px-2 leading-loose no-list">
                  <router-link to="/profile" class="no-underline">
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.general.profile') }}</p>
                  </router-link>
                  <router-link to="/edit-profile" class="no-underline">
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.general.edit_profile') }}</p>
                  </router-link>
                  <router-link :to="{name: 'profile-edit', params: { edit: 'yes', lang: locale }}" class="no-underline">
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.profile_tabs.complete_profile') }}</p>
                  </router-link>
                  <router-link
                    to="/state-subscription"
                    class="no-underline"
                    v-if="(user) ? user.subscription_status === 'active': null"
                  >
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.general.subscription_status') }}</p>
                  </router-link>
                  <router-link to="/renewal-subscription" class="no-underline">
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.general.subscription_renewal') }}</p>
                  </router-link>
                  <a class="cursor-pointer focus:outline-none" @click="sessionLogout">
                    <p
                      @click="isShow = false"
                      class="font-semibold text-gray-700 hover:text-blue-400"
                    >{{ $t('messages.general.logout') }}</p>
                  </a>
                </ul>
              </div>
            </div>
            <div class="pl-3 bg-no-repeat phone:hidden sm:block" style="background-image: url('/storage/image/lang-icon.png'); background-position: left center;">
              <div class="relative flex flex-no-wrap items-center justify-center h-full language-label">
                  <select
                    name="language"
                    :value="locale"
                    v-model="language"
                    @change="changeLocale"
                    class="z-20 px-2 py-1 pr-8 font-semibold bg-transparent rounded appearance-none cursor-pointer focus:outline-none md:py-2 md:pl-4"
                  >
                    <option value="es">{{ $t('messages.languages.spanish') }}</option>
                    <option value="en">{{ $t('messages.languages.english') }}</option>
                  </select>
                  <p class="absolute top-0 right-0 z-10 pb-1 pr-3 text-xl font-semibold cursor-pointer md:pb-2">
                    &#x2304;
                  </p>
              </div>
            </div>

            <!-- MOBILE -->
            <div class="bg-no-repeat phone:block sm:hidden">
              <div class="relative flex flex-no-wrap items-center justify-center h-full language-label">
                  <select
                    name="language"
                    :value="locale"
                    v-model="language"
                    @change="changeLocale"
                    class="z-20 pr-3 py-1 mr-1 pr-6 font-semibold bg-transparent rounded appearance-none cursor-pointer focus:outline-none md:py-2 md:pl-4"
                  >
                    <option value="es">{{ $t('messages.languages.short.spanish') }}</option>
                    <option value="en">{{ $t('messages.languages.short.english') }}</option>
                  </select>
                  <p class="absolute top-0 right-0 z-10 pb-4 pr-3 text-xl font-semibold cursor-pointer md:pb-2 leading-tight">
                    &#x2304;
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <transition name="modal">
      <div v-if="inboundCall.calling">
        <div
          class="z-50 flex items-center justify-center w-full h-full px-2 overlay lg:px-0"
          @click.self="isOpen = false"
        >
          <div class="w-full p-4 mx-auto my-0 bg-white rounded-lg modal md:w-1/2 xl:w-2/5 lg:p-6">
            <div class="container px-0 m-auto lg:px-10">
              <div class="flex justify-center mb-4 text-lg">
                {{ inboundCall.message }}
              </div>
              <div class="flex justify-center">
                <button
                  class="px-4 mx-3 mt-0 text-sm tracking-wide bg-green-500 rounded hover:bg-green-600"
                  @click.prevent="acceptCall"
                >{{ $t('messages.general.accept_call') }}</button>
                <button
                  class="px-4 mx-3 mt-0 text-sm tracking-wide bg-red-500 rounded hover:bg-red-600"
                  @click.prevent="rejectCall"
                >{{ $t('messages.general.reject_call') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal">
      <div v-if="isOpen">
        <div class="z-50 flex items-center justify-center w-full h-full px-2 overlay lg:px-0">
          <div class="w-full p-4 mx-auto my-0 bg-white rounded-lg modal md:w-1/2 xl:w-2/5 lg:p-6">
            <div class="container px-0 m-auto lg:px-10">
              <h1
                class="text-2xl font-bold text-center text-blue-500 uppercase lg:text-3xl"
              >{{ $t('messages.terms_chat.title') }}</h1>
              <p
                class="my-3 text-base font-semibold text-center lg:my-6"
              >{{ $t('messages.terms_chat.description_one') }}</p>
              <p
                class="text-sm font-semibold text-center text-blue-500"
              >{{ $t('messages.terms_chat.description_two') }}</p>
              <p class="mt-6 text-sm text-center text-pink-500 lg:text-base">
                <router-link
                  to="/security"
                  class="font-semibold text-pink-500 hover:text-jblue-primary"
                >{{ $t('messages.terms_chat.tips') }}</router-link>
              </p>
              <form class="w-full mt-3 text-center" @submit.prevent="isLoading ? null : submit()">
                <button
                  class="w-64 py-3 font-semibold text-white no-underline uppercase bg-pink-500 border border-pink-500 rounded hover:bg-white hover:text-pink-500"
                >
                  <template v-if="isLoading">
                    <spinner :size="25" />
                  </template>
                  <template v-else>{{ $t('messages.general.accept') }}</template>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal">
      <div v-if="mobile">
        <div class="z-50 flex items-center justify-center w-full h-full px-2 overlay lg:px-0">
          <div class="w-full p-4 mx-auto my-0 bg-white rounded-lg modal md:w-1/2 xl:w-2/5 lg:p-6">
            <div class="container px-0 m-auto lg:px-10">
              <h1
                class="text-2xl font-bold text-center text-blue-500 uppercase lg:text-3xl"
              >{{ $t('messages.general.phone_comfirm.title') }}</h1>
              <p
                class="my-3 text-base font-semibold text-center lg:my-6"
              >{{ $t('messages.general.phone_comfirm.message') }}</p>
              <div class="w-full">
                <div class="w-full" v-if="!verify">
                  <div class="w-3/4 mx-auto">
                    <label class="font-bold tracking-wide">{{ $t('messages.verify.mobile_phone') }}</label>
                    <vue-tel-input
                      v-model="phone"
                      v-bind="phoneProps"
                      :dynamicPlaceholder="true"
                      v-validate="'required|unique_phone_mobile'"
                      :data-vv-as="$t('messages.step_one.phone')"
                      class="w-full border border-blue py-2"
                    ></vue-tel-input>
                    <ul>
                      <li
                        v-for="(error, index) in errors.collect('telephone')"
                        :key="index"
                        class="text-sm text-red-500 font-semibold mt-2 is-danger"
                      >{{ error }}</li>
                    </ul>
                  </div>
                  <div class="w-3/4 mx-auto">
                    <a
                      href="#"
                      @click.prevent="isSendingCode ? null : send()"
                      class="block text-center font-semibold tracking-wide bg-pink-500 text-white font-semibold rounded px-4 py-4 mt-4 hover:text-pink-500 hover:bg-white border hover:border-pink-500"
                    >
                      <template v-if="isSendingCode">
                        <spinner :size="25" />
                      </template>
                      <template v-else>{{ $t('messages.verify.confirm') }}</template>
                    </a>
                  </div>
                </div>
                <div v-else>
                  <div class="w-3/4 mx-auto">
                    <label class="font-bold tracking-wide">{{ $t('messages.verify.introduce_code') }}</label>
                    <input
                      class="h-10 block border-blue border w-full rounded pl-6 text-center"
                      type="number"
                      v-model="code"
                      name="code"
                      :placeholder="$t('messages.verify.example')"
                    />
                    <span class="text-red-500" v-if="error">{{ $t('messages.verify.incorrect_code') }} </span>
                    <div class="text-blue-800 cursor-pointer" v-if="error" @click.prevent="verify = false">{{ $t('messages.verify.change') }}</div>
                  </div>
                  <div class="w-3/4 mt-4 mx-auto">
                    <a
                      href="#"
                      @click.prevent="isSendingCode ? null : verifyCode()"
                      class="block text-center font-semibold tracking-wide bg-pink-500 text-white font-semibold rounded px-4 py-4 mt-4 hover:text-pink-500 hover:bg-white border hover:border-pink-500"
                    >
                      <template v-if="isSendingCode">
                        <spinner :size="25" />
                      </template>
                      <template v-else>{{ $t('messages.verify.confirm') }}</template></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Spinner from "@/components/Spinner";
import Cookies from "js-cookie";
import bus from "@/bus";
import { Howl, Howler } from 'howler';
import find from 'lodash/find';
import get from 'lodash/get';
import moment from 'moment';
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";
import { verify } from "crypto";

export default {
  name: "Navigation",
  components: {
    Spinner,
    VueTelInput
  },
  data() {
    return {
      supportedPages: [
        'storylove',
        'stories',
        'home',
        'login',
        'support',
        'register',
        'engagement',
        'contact-us',
        'security',
        'privacy',
        'engagement',
        'conduct',
        'messages'
        ],
      language: Cookies.get("locale") ? Cookies.get("locale") : "en",
      isOpen: false,
      isActive: false,
      isShow: false,
      stateMenu: 0,
      stateMenuProfile: 0,
      messagesCount: 0,
      isLoading: false,
      inboundCall: {
        tone: new Howl({
          src: ['/bell.mp3'],
          autoplay: false,
          loop: true,
          volume: 1
        }),
        calling: false,
        user: null,
        session: null,
        userChatId: null,

        inProgress: false,
        timer: null,
        interval: null,
        video: false,
        audio: false,
        external: false,
        message: ''
      },
      friends: [],
      path: '',
      mobile: false,
      phone: null,
      verify: false,
      code: null,
      error: false,
      isSendingCode: false,
      phoneProps: {
        defaultCountry: "",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "7789 4567",
        required: false,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ["SV", "US"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "on",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        },
        validCharactersOnly: true
      }
    };
  },
  mounted() {
    if (this.$route.params.lang) {
      this.language = this.$route.params.lang;
      this.setLocale(this.$route.params.lang);
    }

    bus.$on('phone-validate-required', () => {
      this.mobile = true;
    });

    if (this.hasValidUser()) {
      if (!this.user.status) {
             this.forceLogout();
            this.$router.replace({ name: 'home' });
      }
      this.listenCalls();
      this.updateUserConnection({ user: this.user.id, active: true });
      if (this.user.pictures.length === 0 && this.user.subscription_status !== 'active') {
        this.$swal
          .fire({
            text: this.$t('messages.delete_photo.onLessQuantity.description'),
            confirmButtonText: this.$t('messages.delete_photo.onLessQuantity.accept')
          });
      }

      if (this.user.phone_validate) {

          this.phone = this.user.profile.phone_mobile;
          this.mobile = true;

      } else if (this.user.automatic_phone_validate && !this.user.profile.phone_validate) {

        const country_whitelist = ['AU','GB','CA', 'US'];
        const country_blacklist = ['UG','IN','NG', 'UA'];
        let created = new Date(this.user.profile.created_at);
        let today = new Date();
        let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let dateTime = new Date(date+' '+time);

        let difTime = (dateTime-created) / (1000*60);

        if (difTime >= 2) {

            this.phone = this.user.profile.phone_mobile;
            this.mobile = true;

        } else{
          let timeOut=0;

          //country_whitelist.includes(this.user.profile.country.iso) ? timeOut = 2 : timeOut = 1;
          if (country_whitelist.includes(this.user.profile.country.iso)) {
            timeOut = 1;
            timeOut = (timeOut * 60) - (difTime * 60);
          } else if (country_blacklist.includes(this.user.profile.country.iso)) {
            timeOut = 0;
          } else {
            timeOut = 0.5;
            timeOut = (timeOut * 60) - (difTime * 60);
          }

          setTimeout(() => {
            this.phone = this.user.profile.phone_mobile;
            this.mobile = true;
          }, timeOut * 1000);

        }
      }

      Echo.private(`App.User.${ this.user.id }`)
        .notification(async ({ type }) => {
          if (type === 'App\\Notifications\\ProfileDeleted') {
            this.forceLogout();
            this.$router.replace({ name: 'home' });
          } else if (type === 'App\\Notifications\\ForceLogout') {
            this.forceLogout();
            this.$router.replace({ name: 'home' });
          } else if (type === 'App\\Notifications\\ForcePhoneVerify') {
            this.mobile = true;
          } else if(type === 'App\\Notifications\\ForceReload') {
            location.reload();
          } else {
            await this.fetchUser(true);
          }
        });
    }
  },
  computed: {
    ...mapState('profiles', ['profile']),
    ...mapState("auth", ["user",]),
    ...mapState("locale", ["locale"]),
    ...mapState("stateChat", ["stateCall"]),
    coverUrl() {
      const picture = this.user.pictures.filter(
        photo => photo.status === "approved" && photo.cover === 1
      );
      if (picture.length > 0) {
        return picture[0].url;
      }
      return "/storage/image/placeholder-user.jpg";
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.name === "chat") {
          bus.$on("update-unread", this.unreadListener);
        } else {
          ConnectyCube.chat.onMessageListener = () => {
            this.unreadListener();
            /*this.messagesCount++
            bus.$emit("update-counter-mobile", parseInt(this.messagesCount, 10));*/
          };
          bus.$off("update-unread", this.unreadListener);
        }

        this.path = to.name;
      }
    }
  },
  methods: {
    ...mapActions("profiles", ["getCallerProfile", 'setPaginationPage', "storeSearchParams"]),
    ...mapActions("stateChat", ["updateState", "updateCallState"]),
    ...mapActions("auth", ["fetchUser", "logout", 'forceLogout', 'updateChatAlert', 'updateUserConnection']),
    ...mapActions("locale", ["setLocale"]),
    homeClicked() {
      this.setPaginationPage(1);
      this.storeSearchParams({})
    },
    async send() {
      try {
        this.isSendingCode = true;
        await axios.post("/api/web/code/send", {
          number_phone: this.phone,
          type: "sms"
        });
        this.verify = true;
        this.isSendingCode = false;
      } catch (error) {
        this.isSendingCode = false;
        return error;
      }
    },
    async verifyCode() {
      try {
        this.isSendingCode = true;
        const { data } = await axios.post("/api/web/code/verify", {
          number_phone: this.phone,
          code: this.code
        });
        if (data.verified) {
          await this.fetchUser(true);
          this.mobile = false;
          this.isSendingCode = false;
          return;
        }
        this.error = true;
        this.isSendingCode = false;
      } catch (error) {
        this.isSendingCode = false;
        return error;
      }
    },
    hasValidUser() {
      return !!get(this.user, 'id', null);
    },
    audioPlay () {
      this.inboundCall.tone.play();
      this.inboundCall.calling = true;
    },
    audioStop () {
      this.inboundCall.tone.stop();
      this.inboundCall.calling = false;
    },
    delay: ms => new Promise(res => {
      setTimeout(res, ms)
    }),
    async acceptCall() {
      this.$emit('close');
      this.audioStop();

      if(!this.friends.length) {
        await this.getFriends();
      }

      this.$router.push({
        name: "chat",
        params: {
          random: Date.now(),
          username: this.inboundCall.userChatId,
          lang: this.language,
          external: true,
          call: this.inboundCall,
          receiver: find(this.friends, { opponent_id: this.inboundCall.userChatId }),
          receiver_id: this.user.chat_id
        }
      })
      .catch(() => {});
    },

    rejectCall() {
      this.$emit('close');
      this.inboundCall.session.reject({});
      this.inboundCall.session = null;
      this.onStopCallListener();
    },

    listenCalls() {
      ConnectyCube.videochat.onCallListener = async session => {
        await this.getFriends();
        let { username, chat_id } = await this.getCallerProfile(session.initiatorID);
        this.inboundCall.user = username;
        this.inboundCall.userChatId = chat_id;
        this.inboundCall.calling = true;
        this.inboundCall.video = this.isVideoCall;
        this.inboundCall.message = session.callType === 1
          ? this.$t('messages.general.alert_message.video', { username: this.inboundCall.user })
          : this.$t('messages.general.alert_message.voice', { username: this.inboundCall.user });
        this.audioPlay();

        return this.inboundCall.session = session;
      };

      ConnectyCube.videochat.onAcceptCallListener = this.onAcceptCallListener;
      ConnectyCube.videochat.onRejectCallListener = this.onStopCallListener;
      ConnectyCube.videochat.onStopCallListener = this.onStopCallListener;

      ConnectyCube.videochat.onRemoteStreamListener = (
        session,
        userID,
        remoteStream
      ) => {
        this.inboundCall.session = session;
        session.attachMediaStream("videoReceiver", remoteStream);
      };

      ConnectyCube.videochat.onSessionConnectionStateChangedListener = (
        session,
        userID,
        connectionState
      ) => {
        if (connectionState === ConnectyCube.videochat.SessionConnectionState.DISCONNECTED) {
          this.stopCall();
        }
      };
    },

    stopCall() {
      this.onStopCallListener();
    },

    async getFriends() {
      const friends = await new Promise((resolve) => {
        ConnectyCube.chat.dialog.list({ skip: this.counter, limit: 100 }, (error, dialogs) => {
          resolve(dialogs.items);
        });
      });

      await Promise.all(friends.map(async (friend) => {
        const userId = friend.occupants_ids.find(x => x !== this.user.chat_id);
        const { data } = await axios.get(`/api/web/user/${userId}`);
        friend.profile = data;
        friend.opponent_id = userId;
      }));

      this.friends =friends;
    },

    onAcceptCallListener() {
      this.audioStop();
      this.inboundCall.calling = false;
      this.inboundCall.audio = true;
      this.inboundCall.inProgress = true;
      this.inboundCall.timer = dayjs().startOf("day");
      this.inboundCall.interval = setInterval(() => {
        this.inboundCall.timer = this.inboundCall.timer.add(1, "second");
      }, 1000);
    },

    onStopCallListener() {
      if (this.inboundCall.session) {
        ConnectyCube.videochat.clearSession(this.inboundCall.session.ID);
        this.inboundCall.session.stop({}); // Force stop
        this.inboundCall.session = null;
      }

      this.inboundCall.calling = false;
      this.inboundCall.inProgress = false;

      this.audioStop();
      clearInterval(this.inboundCall.interval);
    },

    isVideoCall() {
      return !!this.inboundCall.session && ConnectyCube.videochat.CallType.VIDEO == 1;
    },

    unreadListener() {

      setTimeout(() => {ConnectyCube.chat.dialog.list(null, (error,result)=>{
          let sumUndreadMessages = {
            total : 0
          }
          let data = result.items;
          data.forEach( x => {
          if(x.name !== null){
            let messages_count = Number(x.unread_messages_count);
            if(messages_count >0){
              sumUndreadMessages.total +=1;
            }
          }
          })
          this.messagesCount = get(sumUndreadMessages, 'total',0);
          bus.$emit("update-counter-mobile", parseInt(this.messagesCount, 10));
        });

      }, 300)
    },
    changeLocale(e) {
      if (e.target.value === 'es' && this.$route.path === '/') {
        this.$router.push({
          path: '/es',
          params: {
            lang: e.target.value
          }});
      } else {
        this.$router.push({ params: {
          lang: e.target.value
        }});
      }

      this.setLocale(e.target.value);
    },
    hideDropdowns(e) {
      this.isActive = false;
      this.isShow = false;
    },
    async submit() {
      this.isLoading = true;
      const isUpdated = await this.updateState();

      if (isUpdated) {
        await this.fetchUser(true);
        this.$router.push({
          name: "chat",
          params: {
            random: Date.now(),
          }
        });
      }

      this.isLoading = false;
      this.isOpen = false;
    },
    sessionLogout() {
      try {
        this.$emit("logout");
        this.setPaginationPage(0);
        this.storeSearchParams({})
      } catch (error) {
        console.log("navigation");
      }
    },
    showActivityOptions(e) {
      if (this.isActive == true && this.stateMenu == 1) {
        this.isActive = false;
        this.stateMenu = 0;
      }
      this.stateMenu = 1;
    },
    showProfileOptions(e) {
      if (this.isShow == true && this.stateMenuProfile == 1) {
        this.isShow = false;
        this.stateMenuProfile = 0;
      }
      this.stateMenuProfile = 1;
    },
    toggleDropdown() {
      if (this.isShow) {
        this.isShow = false;
      }
      if (this.isActive == true) {
        this.isActive = false;
        this.stateMenu = 0;
      } else {
        this.isActive = true;
        this.stateMenu = 2;
      }
    },
    toggleDropdownProfile() {
      if (this.isActive) {
        this.isActive = false;
      }
      if (this.isShow == true) {
        this.isShow = false;
        this.stateMenuProfile = 0;
      } else {
        this.isShow = true;
        this.stateMenuProfile = 2;
      }
    },
    showChatPolicies() {
      const today = moment();
      const last_display = moment.unix(this.user.profile.chat_alert);
      const diff = today.diff(last_display, 'days', true);

      return !last_display ? true : diff >= 60;
    },
    async openChat() {
      if (this.user.profile.state_chat === 0) {
        this.isOpen = true;
        await this.updateChatAlert();
      } else {
        this.isOpen = this.showChatPolicies();

        this.$router.push({
          name: "chat",
          params: {
            random: Date.now(),
            lang: this.locale
          }
        });
      }
    }
  },
  async created() {
    if (this.hasValidUser()) {
      await this.fetchUser();

      // Get messages count
      setTimeout(() => {
        ConnectyCube.chat.dialog.list(null, (error,result)=>{
          let sumUndreadMessages = {
            total : 0
          }
          let data = result.items;
          data.forEach( x => {
          if(x.name !== null){
            let messages_count = Number(x.unread_messages_count);
            if(messages_count >0){
              sumUndreadMessages.total +=1;
            }
          }
          })
          this.messagesCount = get(sumUndreadMessages, 'total',0);
          bus.$emit("update-counter-mobile", parseInt(this.messagesCount, 10));
        });

      }, 3000);

      document.addEventListener("click", this.showActivityOptions);
      document.addEventListener("click", this.showProfileOptions);
    }
  },
  destroyed() {
    document.removeEventListener("click", this.showActivityOptions);
    document.removeEventListener("click", this.showProfileOptions);
  }
};
</script>
<style lang="scss">
.modal {
  transition: all 2s ease-in;
}
.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}
button {
  padding: 7px;
  margin-top: 10px;
  color: white;
  font-size: 1.1rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  background: #292f3d94;
  transition: opacity 1s ease;
}
.show__options {
  height: auto;
  opacity: 1;
  visibility: visible;
}
.vue-slider-dot-handle {
  border: 2px solid white !important;
}
.object-cover {
  object-fit: cover;
}
.no-list {
  list-style: none;
}
.dropdown {
  &__header {
    cursor: pointer;
    position: relative;
    text-overflow: ellipsis;
    &.is-active {
      i.fa {
        &.fa-angle-up {
          opacity: 1;
        }
        &.fa-angle-down {
          opacity: 0;
        }
      }
      + .dropdown__content {
        height: auto;
        opacity: 1;
        visibility: visible;
      }
    }
    &.is-showProfile {
      i.fa {
        &.fa-angle-up {
          opacity: 1;
        }
        &.fa-angle-down {
          opacity: 0;
        }
      }
      + .dropdown__content {
        height: auto;
        opacity: 1;
        visibility: visible;
      }
    }
  }
  &__content {
    height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 15px 10px;
    transition: opacity 0.3s;
    visibility: hidden;
    min-width: 175px;
    overflow: auto;
    z-index: 1;
    position: absolute;
  }
}
</style>
